<template>
  <div>
    <div style="width: 700px;margin-left: 30px;">
      <div id='printBill'>
        <div style="font-size: 8px;color: #141414;font-family: 楷体;">
          <div style="width: 100%;text-align: center;margin-top: 30px;font-size: 20px;">中奥物业 收款收据</div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 70%;">房号：{{deposit.house}}</div>
            <div style="width: 30%;margin-left: 220px;">付款方式：{{deposit.payment_name}}</div>
          </div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 33%;">业主：{{deposit.name}}</div>
            <div style="width: 33%;">收据单号：{{deposit.bill_number}}</div>
            <div style="width: 34%;text-align: right;margin-right: 25px;">开票日期：{{deposit_date}}</div>
          </div>
          <div style="margin-top:1px;line-height: 17px;">
            <table align="center" style="width: 100%;border-collapse: collapse;">
                <tr>
                    <th style="border:1px solid #000000;width: 150px;" align="center" valign="middle">收费项目</th>
                    <th style="border:1px solid #000000;width: 200px;" align="center" valign="middle">收取日期</th>
                    <th style="border:1px solid #000000;width: 90px;" class="ddd" align="center" valign="middle">面积</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">数量</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">收取押金</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">退还押金</th>
                    <th style="border:1px solid #000000;width: 90px;" align="center" valign="middle">金额</th>
                </tr>
                <tr>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{deposit.deposit_type}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{deposit.charge_date}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle"></td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">1</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{deposit.charge_money}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{deposit.retreat_money}}</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{(deposit.charge_money-deposit.retreat_money).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td style="border:1px solid #000000;" align="center" valign="middle">合计（大写）：</td>
                    <td style="border:1px solid #000000;text-align: left;" colspan="4" align="center" valign="middle">
                      <span style="margin-left: 5px;">{{capitalize}}</span>
                    </td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">（小写）：</td>
                    <td style="border:1px solid #000000;" align="center" valign="middle">{{(deposit.charge_money-deposit.retreat_money).toFixed(2)}}</td>
                </tr>
                <tr>
                    <td style="border:1px solid #000000;" align="center" valign="middle">备注：</td>
                    <td style="border:1px solid #000000;text-align: left;" colspan="6" align="center" valign="middle">
                      <span style="margin-left: 5px;">{{deposit.beizhus}}</span>
                    </td>
                </tr>
            </table>
          </div>
          <div style="width: 70%;margin-top: 20px;">说明：第一联为存根（白色），第二联为客户（红色），第三联为记账（黄色）</div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 33%;">开票人：{{login_name}}</div>
            <div style="width: 33%;">收款人：{{deposit.payee}}</div>
            <div style="width: 34%;text-align: right;margin-right: 94px;">收款单位（盖章）</div>
          </div>
          <div style="margin-top: 7px;display: flex;width: 100%;">
            <div style="width: 33%;"></div>
            <div style="width: 33%;"></div>
            <div style="width: 34%;text-align: right;margin-right: 70px;">
              打印时间：{{deposit_date}}
            </div>
          </div>
          <div style="text-align: center;margin-top: 7px;">打印次数<span style="margin-left: 30px;">{{deposit.frequency}}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    data: {
      type: [Array, Object],
      default() {
        return []
      }
    },
  },
  watch:{
    data(newValue,oldValue){
      this.datas(newValue);
    }
  },
  data () {
    return {
      login:'',
      indexs:'',
      chakana:[],
      state:0,
      orderDates:[],
      sdate:'',
      enddate:'',
      homeName:'',
      deposit:[],
      deposit_date:'',
      goods:[],
      capitalize:'',
      login_name:'',
    }
  },
  //界面没出来前加载
  created() {
  },
  //事件
  methods: {
    //数据处理
    datas(it){
      let money =  it.data[0].charge_money-it.data[0].retreat_money;
      this.capitalize = this.transCnMoney(money);
      this.deposit = it.data[0];
      this.login_name = it.bill[0].login_name;
      this.deposit_date = it.bill[0].date;
    },
    //数字转大写
    transCnMoney(number){
       var CN_MONEY = "";
       var CN_UNIT = "仟佰拾亿仟佰拾万仟佰拾元角分";
          number =  parseFloat(number).toFixed(2).toString();//浏览器默认为整数型,将数字转为2位有效数字的float类型再转为字符串
       var dot = number.indexOf('.');//将从小数点开始分开
       if(dot >=0){
          number = number.substring(0,dot)+number.substr(dot+1,2);
          CN_UNIT=CN_UNIT.substr(CN_UNIT.length-number.length);
          for (var i = 0; i < number.length; i++){
           CN_MONEY += '零壹贰叁肆伍陆柒捌玖'.substr(number.substr(i, 1), 1) + CN_UNIT.substr(i, 1);
          }
          return CN_MONEY.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元");
        }else{

        }
    },
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/bill/deposit.vue